import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';

export const useDeleteClientDocument = () => {
  const { doFetch: deleteClientDocument } = useFetch<void, void>();

  return useMutation({
    mutationFn: (documentId: number) => {
      return deleteClientDocument(`/api/documents/${documentId}`, {
        method: 'DELETE',
      });
    },
  });
};
